// utils/colorUtils.ts

import { ColorPalette } from "./types"

/**
 * Predefined color palette based on the provided image
 * Each color has a base and light variant for the radial effect
 */
const COLOR_PALETTE: ColorPalette[] = [
  { base: "#FF7043", light: "#FFA270" }, // Orange
  { base: "#E91E63", light: "#FF4081" }, // Pink
  { base: "#F06292", light: "#FF94C2" }, // Light Pink
  { base: "#9C27B0", light: "#BA68C8" }, // Purple
  { base: "#673AB7", light: "#9575CD" }, // Deep Purple
  { base: "#3F51B5", light: "#7986CB" }, // Indigo
  { base: "#2196F3", light: "#64B5F6" }, // Blue
  { base: "#03A9F4", light: "#4FC3F7" }, // Light Blue
  { base: "#00BCD4", light: "#4DD0E1" }, // Cyan
  { base: "#009688", light: "#4DB6AC" }, // Teal
  { base: "#4CAF50", light: "#81C784" }, // Green
  { base: "#8BC34A", light: "#AED581" }, // Light Green
  { base: "#CDDC39", light: "#DCE775" }, // Lime
  { base: "#FFC107", light: "#FFD54F" }, // Amber
  { base: "#FF9800", light: "#FFB74D" }, // Orange
  { base: "#FF5722", light: "#FF8A65" }, // Deep Orange
  { base: "#795548", light: "#A1887F" }, // Brown
  { base: "#D32F2F", light: "#E57373" }, // Red
  { base: "#1A237E", light: "#3949AB" }, // Dark Blue
  { base: "#004D40", light: "#00796B" }, // Dark Teal
  { base: "#1B5E20", light: "#2E7D32" }, // Dark Green
  { base: "#33691E", light: "#558B2F" }, // Dark Lime
  { base: "#3E2723", light: "#5D4037" }, // Dark Brown
]

/**
 * Generates a deterministic color from the COLOR_PALETTE based on input string
 * @param input - String to generate color from
 * @returns ColorPalette object containing base and light colors
 */
export const generateDeterministicColor = (input: string): ColorPalette => {
  // Create a simple hash of the input string
  const hash = Array.from(input).reduce(
    (acc, char) => char.charCodeAt(0) + ((acc << 5) - acc),
    0
  )

  // Ensure positive index
  const positiveHash = Math.abs(hash)

  // Get deterministic index from hash
  const colorIndex = positiveHash % COLOR_PALETTE.length

  return COLOR_PALETTE[colorIndex]
}
